import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const navItems = [
  { to: '/', label: '首页', end: true },
  { to: '/news', label: '最新爆料', end: false },
  { to: '/about', label: '关于我们', end: false },
  { to: '/faq', label: '常见问题', end: false },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCatOpen(false);
  }, [location.pathname, location.search]);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        {/* 品牌 */}
        <Link to="/" className="group flex shrink-0 items-center gap-2.5" aria-label="每日新料 首页">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 shadow-soft">
            <i className="ri-flashlight-fill text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-tight text-foreground-900 group-hover:text-primary-700">
              每日新料
            </span>
            <span className="mt-0.5 text-[11px] font-medium tracking-wider text-foreground-500">数码圈一手爆料</span>
          </span>
        </Link>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? 'bg-primary-50 text-primary-700' : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          {/* 栏目下拉 */}
          <div className="relative">
            <button
              type="button"
              onClick={() => setCatOpen((v) => !v)}
              className="flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-900"
              aria-haspopup="true"
              aria-expanded={catOpen}
            >
              栏目分类
              <i className={`ri-arrow-down-s-line text-base transition-transform ${catOpen ? 'rotate-180' : ''}`} aria-hidden="true" />
            </button>
            {catOpen && (
              <div className="absolute left-0 top-full mt-2 w-56 overflow-hidden rounded-xl border border-background-200 bg-background-50 p-1.5 shadow-soft">
                <Link to="/news" className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100">
                  <i className="ri-stack-line text-primary-600" aria-hidden="true" />
                  全部爆料
                </Link>
                {categories.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/news?cat=${c.slug}`}
                    className="flex items-center justify-between rounded-lg px-3 py-2 text-sm text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
                  >
                    <span className="flex items-center gap-2">
                      <i className="ri-fire-line text-accent-500" aria-hidden="true" />
                      {c.name}
                    </span>
                    <span className="text-xs text-foreground-400">{c.count}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </nav>

        {/* 右侧操作 */}
        <div className="flex items-center gap-2">
          <Link
            to="/about#contact"
            className="hidden whitespace-nowrap items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-mail-send-line" aria-hidden="true" />
            联系我们
          </Link>
          {/* 移动端菜单按钮 */}
          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 text-foreground-700 lg:hidden"
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={mobileOpen}
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* 移动端面板 */}
      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-2.5 text-sm font-medium ${
                    isActive ? 'bg-primary-50 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-3 border-t border-background-200 pt-3">
            <p className="px-1 pb-2 text-xs font-semibold tracking-wide text-foreground-500">栏目分类</p>
            <div className="flex flex-wrap gap-2">
              {categories.map((c) => (
                <Link
                  key={c.slug}
                  to={`/news?cat=${c.slug}`}
                  className="whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                >
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}